import { useQuery } from '@tanstack/react-query';
import { executeGraphql } from '../graphql/execute';
import { GetLatestPosts } from '../graphql/queries/posts';

export const useLatestPosts = (enabled: boolean = true) => {
  return useQuery({
    queryKey: ['latestPosts'],
    queryFn: () => executeGraphql(GetLatestPosts, {}),
    enabled,
    staleTime: 1000 * 60 * 5,
  });
};
